import type { FC } from "react";

interface StarRatingProps {
    score: number;
    /** BEM block the star element classes hang off, e.g. "nearby-facility-item"
     *  renders "nearby-facility-item__stars" / "…__star--full". */
    classPrefix: string;
}

/** Five-star review display, rounded to the nearest half star. Extracted from
 *  NearbyFacilityItem (WEB-407) for reuse by the market-template facility
 *  header (WEB-704); markup is unchanged apart from the class prefix. */
export const StarRating: FC<StarRatingProps> = ({ score, classPrefix }) => {
    const rounded = Math.round(score * 2) / 2; // nearest half
    return (
        <span
            className={`${classPrefix}__stars tw:inline-flex tw:items-center`}
            aria-hidden="true"
        >
            {Array.from({ length: 5 }, (_, i) => {
                const fill =
                    rounded >= i + 1
                        ? "full"
                        : rounded >= i + 0.5
                          ? "half"
                          : "empty";
                return (
                    <svg
                        key={i}
                        className={`${classPrefix}__star ${classPrefix}__star--${fill} tw:w-4 tw:h-4`}
                        viewBox="0 0 20 20"
                    >
                        <path
                            d="M10 1.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L10 15l-5.2 2.7 1-5.8L1.5 7.7l5.9-.9z"
                            fill={fill === "empty" ? "#d1d5db" : "currentColor"}
                        />
                    </svg>
                );
            })}
        </span>
    );
};
